<template>
  <div id="add">
    <GlobalHeaderNav />
    <router-view />
    <div style="height: 100px"></div>
    <div class="flex_butt">
      <router-link to="/about" style="color: #000;text-decoration: none;">
        <div class="f16">{{$t('about.title')}}</div>
      </router-link>
      <div class="f16">{{$t('public.copyright')}}</div>
    </div>
  </div>
</template>

<script>
import GlobalHeaderNav from "./components/GlobalHeaderNav.vue";
export default {
  name: "App",
  components: {
    GlobalHeaderNav,
  },
};
</script>

<style>
@import "@/assets/css/style.css";
.flex_butt {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 0;
  color: #666666;
  text-align: center;
  border-top: 1px solid rgba(187, 187, 187, 1);
  background-color: #fff;
}
</style>
